import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import { AppState } from '../../../redux';
import { SlideSheetService } from '../../../services/slide-sheet.service';
import { contactTemplateConfigSelector } from '../../../tamalelibs/redux/contact.reducer';
import { ExchangeService } from '../../../tamalelibs/services/exchange.service';
import { NotificationOptions, NotificationStyles } from '../../../widgets/notification/notification.model';
import { ToastService } from '../../../widgets/toast/toast.service';
import { SlideSheetActionTypes } from '../../slide-sheet/slide-sheet.model';
import * as _lodash from 'lodash';
import { ExchagnePanelService } from './exchange-panel.service';
import { contactDefField } from '../../template-setting-dialog/template-setting-dialog.model';
import { ContactDialogSectionName } from '../../contact-detail-new/contact-body-detail.model';
import { ControlId } from '../../contact-dialog-new/contact-dialog.model';

@Component({
    selector: 'tam-exchange-panel',
    templateUrl: './exchange-panel.component.html',
    styleUrls: ['./exchange-panel.component.scss']
})
export class ExchangePanelComponent implements OnInit, OnDestroy {
    config: any;
    emailSource: Array<string>;
    addressSource: Array<string>;
    phoneSource: Array<string>;
    internetSource: Array<string>;
    shareData: Array<string>;
    lastValue = '';
    dataSource: any;
    attributeArray = [];
    /**
     * a flag indicating whether the apply operation is ongoing.
     */
    isSaving = false;

    private _emailSource: Array<string>;
    private _addressSource: Array<string>;
    private _phoneSource: Array<string>;
    private _internetSource: Array<string>;
    private _tamaleConfig: any;
    private _attrArray = [];
    private _destroySubscriptions: Array<Subscription> = [];
    constructor(
        private _exchangeService: ExchangeService,
        private _toast: ToastService,
        private _store: Store<AppState>,
        private _slideSheetService: SlideSheetService,
        private _exchangePanelService: ExchagnePanelService,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._store.pipe(select(contactTemplateConfigSelector)).subscribe(res =>
                this._initContactTemplate(res)
            ));
        this._exchangeService.getConfigMap().subscribe(res => {
            this.config = res.config;
            // tslint:disable-next-line: no-shadowed-variable
            this._exchangeService.getConfigDataSource().subscribe(res => {
                this._setDataSource(res.config);
            });
        });
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    addControl(item) {
        if (item.TDataSource.length > 0) {
            item.container.push({
                deletable: true,
                exchangeEditable: true,
                exchangeName: item.EDataSource[0],
                tamaleEditable: true,
                tamaleName: item.TDataSource[0],
            });
            switch (item.tamaleDS) {
                case 'Emails':
                    this.emailSource.splice(0, 1);
                    break;
                case 'Address':
                    this.addressSource.splice(0, 1);
                    break;
                case 'Phone':
                    this.phoneSource.splice(0, 1);
                    break;
                case 'Internet':
                    this.internetSource.splice(0, 1);
                    break;
            }
        }
    }

    clickClose() {
        this._slideSheetService.slideSheetActionSubject$.next({
            type: SlideSheetActionTypes.CLOSE,
            payload: null
        });
    }

    clickSave() {
        const a = {};
        this.isSaving = true;
        this._exchangeService.putConfigMap({ 'config': this.config }).subscribe(res => {
            this._notifyHandler('Mapping is saved successfully.', 0);
            this.clickClose();
            this._exchangePanelService.exchangeSave$.next(res);
            this.isSaving = false;
        }, err => this.isSaving = false);
    }

    clickResetToDefault() {
        this._exchangeService.resetMapping().subscribe(res => {
            this._notifyHandler('Mapping is reset to default.', 1);
            this.clickClose();
            this._exchangePanelService.exchangeSave$.next(res);
        });
    }

    deleteControl(item, index, tamaleName, exchagneName) {
        item.container.splice(index, 1);
        if (item.tamaleDS === 'Emails') {
            this.emailSource.push(tamaleName);
        } else if (item.tamaleDS === 'Phone') {
            this.phoneSource.push(tamaleName);
        } else if (item.tamaleDS === 'Internet') {
            this.internetSource.push(tamaleName);
        } else if (item.tamaleDS === 'Address') {
            this.addressSource.push(tamaleName);
        }
        if (exchagneName) {
            item.EDataSource.push(exchagneName);
        }
    }

    trackByFn(index, item) {
        return item.id;
    }

    valueChangeT(value, item) {
        const selectItems = item.container.map(element => element.tamaleName);
        if (item.tamaleDS === ControlId.Email) {
            this.emailSource = this._emailSource.filter(i => selectItems.indexOf(i) === -1);
        } else if (item.tamaleDS === ControlId.Phone) {
            this.phoneSource = this._phoneSource.filter(i => selectItems.indexOf(i) === -1);
        } else if (item.tamaleDS === ControlId.Internet) {
            this.internetSource = this._internetSource.filter(i => selectItems.indexOf(i) === -1);
        } else if (item.tamaleDS === ControlId.Address) {
            this.addressSource = this._addressSource.filter(i => selectItems.indexOf(i) === -1);
        }
        // set data source after change Tamale item.
        this.config.forEach(data => {
            if (data.tamaleDS === item.tamaleDS) {
                if (data.tamaleDS === ControlId.Email) {
                    data['TDataSource'] = this.emailSource;
                } else if (data.tamaleDS === ControlId.Phone) {
                    data['TDataSource'] = this.phoneSource;
                } else if (data.tamaleDS === ControlId.Internet) {
                    data['TDataSource'] = this.internetSource;
                } else if (data.tamaleDS === ControlId.Address) {
                    data['TDataSource'] = this.addressSource;
                }
            }
        });
    }

    valueChangeE(value, item, index) {
        let selectItems = [];
        // Due to config[0] and config[1] use the same dateSource,
        // We need to align the options in both areas.
        if (index === 0 || index === 1) {
            this.config.forEach((data, i) => {
                if (i === 0 || i === 1) {
                    selectItems = selectItems.concat(data.container.map(element => element.exchangeName));
                }
            });
        } else {
            selectItems = item.container.map(element => element.exchangeName);
        }

        let values = [];
        values = item.EAllDataSource.filter(i => selectItems.indexOf(i) === -1);
        if (values.findIndex(a => a === '') === -1) {
            values.splice(0, 0, '');
        }

        // data needs to be synchronized for config[0].EDataSource and config[1].EDataSource
        this.config.forEach((element) => {
            if (element.exchangeDS === item.exchangeDS) {
                element['EDataSource'] = values;
            }
        });
    }

    private _initContactTemplate(res) {
        this._tamaleConfig = res.contains;
        this._isExistAttribute();
        res.contains.forEach(item => {
            switch (item.sectionName) {
                case ContactDialogSectionName.Address:
                    this.addressSource = item.container[0][0].dataSource.map(data => data.name);
                    this.addressSource.forEach((element, index) => {
                        if (element.indexOf('Address') === -1) {
                            this.addressSource[index] = element + ' Address';
                        }
                    });
                    this._addressSource = _lodash.cloneDeep(this.addressSource);
                    break;
                case ContactDialogSectionName.ContactInformation:
                    this.phoneSource = item.container[0][0].dataSource.map(data => data.name);
                    this.emailSource = item.container[1][0].dataSource.map(data => data.name);
                    this.phoneSource.forEach((element, index) => {
                        if (element.indexOf('Phone Number') === -1) {
                            this.phoneSource[index] = element + ' Phone Number';
                        }
                    });
                    this.emailSource.forEach((element, index) => {
                        if (element.indexOf('Email') === -1) {
                            this.emailSource[index] = element + ' Email';
                        }
                    });
                    this._phoneSource = _lodash.cloneDeep(this.phoneSource);
                    this._emailSource = _lodash.cloneDeep(this.emailSource);
                    break;
                case ContactDialogSectionName.Internet:
                    this.internetSource = item.container[0][0].dataSource.map(data => data.name);
                    this._internetSource = _lodash.cloneDeep(this.internetSource);
                    break;
            }

        });
    }

    private _notifyHandler(info, type) {
        const note = new NotificationOptions();
        switch (type) {
            case 0:
                note.style = NotificationStyles.Success;
                break;
            case 1:
                note.style = NotificationStyles.Info;
                break;
            default:
                break;
        }
        note.message = info;
        this._toast.notify(note);
    }

    private _setDataSource(res) {
        this.dataSource = res;
        if (this.config) {
            this.config.forEach(item => {
                item.container.forEach(element => {
                    if (element.tamaleName) {
                        this.emailSource = this.emailSource.filter(a => a !== element.tamaleName);
                        this.phoneSource = this.phoneSource.filter(a => a !== element.tamaleName);
                        this.addressSource = this.addressSource.filter(a => a !== element.tamaleName);
                        this.internetSource = this.internetSource.filter(a => a !== element.tamaleName);
                    }
                });
            });
            this._setConfig(res);
            this.config.forEach(element => {
                element.container.forEach((name, index) => {
                    if (element.EDataSource && element.EDataSource.length > 0 && name.exchangeName) {
                        element['EDataSource'] = element.EDataSource.filter(a => a !== name.exchangeName);
                    }

                    if (name.tamaleName === contactDefField.Prefix || name.tamaleName === contactDefField.MiddleName || name.tamaleName === contactDefField.Suffix || name.tamaleName === contactDefField.Gender) {
                        if (this._attrArray.indexOf(name.tamaleName) === -1) {
                            element.container = element.container.filter(configItem => configItem.tamaleName !== name.tamaleName);
                        }
                    }
                });
            });

            // after saving condition
            if (this.config[1].EDataSource && this.config[1].EDataSource.length > 1) {
                this.config[0].container.forEach(item => {
                    this.config[0].EDataSource = this.config[1].EDataSource = this.config[1].EDataSource.filter(a => a !== item.exchangeName);
                });
            }

            // set tamale attributes config
            this._setTamaleAttribute();
        }
    }

    private _isExistAttribute() {
        this._tamaleConfig[0].container.forEach(element => {
            element.forEach(item => {
                const name = item.config.controlName;
                switch (name) {
                    case contactDefField.Prefix:
                    case contactDefField.MiddleName:
                    case contactDefField.Suffix:
                    case contactDefField.Gender:
                        this._attrArray.push(name);
                        break;
                }
            });
        });
    }


    /**
     * set tamale attributes config
     *
     * @private
     * @memberof ExchangePanelComponent
     */
    private _setTamaleAttribute() {
        let attributeIndex = 0;
        this._tamaleConfig[0].container.forEach(element => {
            element.forEach(item => {
                const name = item.config.controlName;
                switch (name) {
                    case contactDefField.Prefix:
                    case contactDefField.MiddleName:
                    case contactDefField.Suffix:
                    case contactDefField.Gender:
                        if (this.config[1].container && this.config[1].exchangeDS === 'Others') {
                            if (this.config[1].container.findIndex(content => content.tamaleName === name) === -1) {
                                this.config[1].container.push({
                                    deletable: false,
                                    exchangeEditable: true,
                                    tamaleEditable: false,
                                    tamaleName: name
                                });
                                this.config[1]['EDataSource'] = this.config[0].EDataSource;
                            }
                        } else {
                            this.config.splice(1, 0, {
                                container: [{
                                    deletable: false,
                                    exchangeEditable: true,
                                    tamaleEditable: false,
                                    tamaleName: name
                                }],
                                EDataSource: this.config[0].EDataSource,
                                exchangeDS: 'Others',
                                EAllDataSource: this.config[0].EAllDataSource,
                            });
                            attributeIndex++;
                        }
                        // }
                        break;
                }
            });
        });
        this._tamaleConfig[6].container.forEach(element => {
            element.forEach(item => {
                const name = item.config.controlName;
                switch (name) {
                    case contactDefField.Gender:
                        this.config[1].container.push({
                            deletable: false,
                            exchangeEditable: true,
                            EDataSource: this.config[0].EDataSource,
                            tamaleEditable: false,
                            tamaleName: name
                        });
                        this.config[1]['EDataSource'] = this.config[0].EDataSource;
                        break;
                }
            });
        });
    }

    private _setConfig(res) {
        this.config.forEach(item => {
            res.forEach(element => {
                if (element.exchangeDS === item.exchangeDS) {
                    item.container.forEach(content => {
                        item['EDataSource'] = _lodash.cloneDeep(element.meta);
                        item['EAllDataSource'] = _lodash.cloneDeep(element.meta);
                    });
                    item.EDataSource.splice(0, 0, '');
                    item.EAllDataSource.splice(0, 0, '');
                }
                if (item.tamaleDS === ControlId.Email) {
                    item['TDataSource'] = this.emailSource;
                } else if (item.tamaleDS === ControlId.Phone) {
                    item['TDataSource'] = this.phoneSource;
                } else if (item.tamaleDS === ControlId.Internet) {
                    item['TDataSource'] = this.internetSource;
                } else if (item.tamaleDS === ControlId.Address) {
                    item['TDataSource'] = this.addressSource;
                }
            });
        });
    }
}
